// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__Rmw7l","coloredSquare":"Tag_coloredSquare__4yU+d","delete_button":"Tag_delete_button__QkQUW"};